function initTabbedSlider(section) {
  if (!section || !(section instanceof HTMLElement)) {
    return;
  }
  const swiperElement = section.querySelector('.js-tabbed-slider');
  const swiperTabsElement = section.querySelector('.js-tabbed-slider-tabs');
  if (!swiperElement || !swiperTabsElement) {
    return;
  }
  const tabs = section.querySelectorAll('.tabbed-slider_tabs_item');
  const sliderSpeed = parseInt(swiperElement.dataset.sliderSpeed, 10) || 500;
  
  const swiperTabs = new Swiper(swiperTabsElement, {
    slidesPerView: 'auto'
  });

  const swiper = new Swiper(swiperElement, {
    slidesPerView: 1,
    spaceBetween: 32,
    autoHeight: true,
    autoplay: false,
    speed: sliderSpeed,
    pauseOnMouseEnter: true,
    
  });

  // Tab click event

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const index = parseInt(tab.getAttribute('data-index'), 10);
      if (isNaN(index)) return;

      // Remove active class from all tabs
      tabs.forEach((t) => t.classList.remove('active'));
      // Add active class to the clicked tab
      tab.classList.add('active');

      // Slide to the corresponding slide
      swiper.slideTo(index);
      swiperTabs.slideTo(index);
    });
  });

  // Update active tab on slide change
  swiper.on('slideChange', () => {
    const activeIndex = swiper.activeIndex;
    tabs.forEach((tab, idx) => {
      if (idx === activeIndex) {
        tab.classList.add('active');
        swiperTabs.slideTo(activeIndex);
      } else {
        tab.classList.remove('active');
      }
    });
  });
}

window.addEventListener('load', function () {
  const tabbedSliderSection = document.querySelector('.js-tabbed-slider');
  if (!tabbedSliderSection) {
    return;
  }
  initTabbedSlider(tabbedSliderSection);
});